import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { makeStyles } from 'tss-react/mui';

import TicketsManager from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles()(theme => ({
	chatContainer: {
		flex: 1,
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
	},

	chatPapper: {
		display: "flex",
		height: "100%",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
	},
	welcomeMsg: {
		backgroundColor: theme.palette.mode === "light" ? "#eee" : theme.palette.background.default,
		color: theme.palette.text.secondary,
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
	},
}));

const TicketsCustom = () => {
	const { classes } = useStyles();
	const { ticketId } = useParams();

	return (
        <div className={classes.chatContainer}>
            <div className={classes.chatPapper}>
				<Grid container spacing={0}>
					<Grid className={classes.contactsWrapper} size={4}>
						<TicketsManager />
					</Grid>
					<Grid className={classes.messagesWrapper} size={8}>
						{ticketId ? (
							<>
								<Ticket />
							</>
						) : (
							<Paper square variant="outlined" className={classes.welcomeMsg}>
								<span>{i18n.t("chat.noTicketMessage")}</span>
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
        </div>
    );
};

export default TicketsCustom;
